import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TripService } from '../../providers/trip-service/trip-service';
import { GoogleProvider } from '../../providers/google/google';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';
import * as parseAddress from 'parse-address';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as $ from 'jquery';
import * as numeral from 'numeral';
import * as turf from '@turf/turf';
import {
  LoadingController,
  NavController,
  ModalController,
  ViewController,
  App,
  AlertController,
} from 'ionic-angular';
import { Platform } from 'ionic-angular';
import { ToolsProvider } from '../../providers/tools/tools';
import { EnvVariables } from '../../environments/environment';

@Component({
  selector: 'trip-timeline',
  templateUrl: 'trip-timeline.html',
})
export class TripTimelineComponent {
  log = debug('app:TripTimelineComponent');

  @Input()
  trip: any = [];

  @Input()
  activeTrip = false;
  waypoints: any = [];
  origin: any = [];
  destination: any = [];
  showTimeline = false;
  userDotLocation: any;
  userDotLocationIndex: any;
  userDotActiveWaypoint = null;
  userDistanceAlongRoute = null;
  userPercentageAlongRoute = null;
  @Output() routePercentageComplete = new EventEmitter();
  totalTripMiles = null;
  inited = false;
  subs = [];
  smallScreen = false;
  timelineStatesMaxHeight = '100%';
  staticRouteCache = [];

  nextStopDistance;
  interval;

  loading = true;
  statsLoaded = false;
  @Input() timelineStats = false;
  @Input() forceShowCompletedTrip = false;
  stopsCompleted = 0;
  @Output() restartTrip = new EventEmitter();
  @Output() deleteTrip = new EventEmitter();

  // for optional toggling
  @Input() toggleHeaderSection = true;
  @Input() toggleDetailsSection = true;
  @Input() toggleStatsSection = true;
  @Input() toggleTimelineSection = true;

  optimizedTruckRoute = false;

  constructor(
    public tripService: TripService,
    public geolocation: GeolocationProvider,
    public google: GoogleProvider,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public app: App,
    public tools: ToolsProvider,
    public env: EnvVariables
  ) {
    window;

    this.interval = setInterval(() => {
      if (this.activeTrip) {
        if (document.hasFocus()) {
          this.log('running timeline interval for active trip');
          this.geolocation.getRecentPosition().then(loc => {
            this.log('loc', loc);
            this.setDurationToStops(loc, this.destination);
          });
        }
      }
    }, 30000);
  }

  ngOnInit() {
    if (this.forceShowCompletedTrip) {
      this.timelineStats = true;
      this.toggleTimelineSection = false;
      // this.toggleDetailsSection = false;
      // this.toggleHeaderSection = false;
      this.geolocation.getRecentPosition().then(loc => {
        this.log('3 show location, dest', loc, this.destination, this.trip);
        this.setDurationToStops(loc, _.get(this.trip, 'destination'));
      });
    }
    setTimeout(() => {
      this.loading = true;
      this.setTripTimeline(this.trip);
      setTimeout(() => {
        this.loading = false;
        this.tools.emit('timelineLoaded');
        this.setTimelineStateMaxHeight();
      }, 2000);
      if (this.platform.width() <= 350) {
        this.smallScreen = true;
      }

      this.setHeights();

      this.subs.push(
        this.tripService.on('updatedTripStats', trip => {
          if (_.get(trip, 'tripStats')) {
            this.trip.tripStats = _.get(trip, 'tripStats');
          }
        })
      );

      this.subs.push(
        this.tools.on('endingRoute', () => {
          clearInterval(this.interval);
        })
      );
    });
  }

  private setTimelineStateMaxHeight() {
    const canvasHeight = $('.mapboxgl-canvas').height() || 0,
      timelineHeader = $('.Timeline-header').height() || 38,
      timelineViewDetails = $('.Timeline-viewDetails').height() || 12,
      // timelineWaypointsHeight = $('.Timeline-waypoints').height() || 0,
      timelineDestinations = $('.Timeline-destination').height();

    let timelinePadding = 20;
    if (window.innerWidth < 350) {
      timelinePadding = 0;
    }

    const availableSpace =
      canvasHeight -
      (timelineHeader +
        timelineViewDetails +
        timelineDestinations +
        // timelineWaypointsHeight +
        timelinePadding) -
      40;
    this.timelineStatesMaxHeight = _.toString(availableSpace) + 'px';
  }

  ngOnChanges() {}

  private setTripTimeline(trip) {
    this.geolocation.getRecentLocationPlace().then(userLocation => {
      if (!_.size(trip)) {
        return;
      }
      //TODO: need to get route waypoint distances
      // and get active location nearest waypoint
      let placeTypes = this.tripService.placeTypes;

      // this.log('placeTypes for TripTimeline', placeTypes);

      if (_.get(trip.origin, 'placeType') === 'CURRENT_LOCATION') {
        this.origin.name = _.get(this.trip.origin, 'description');
      } else {
        this.origin.name =
          _.get(this.trip.origin.location, 'address') ||
          _.get(this.trip.origin, 'name');
      }

      this.log('setting optimized', trip);
      if (_.get(trip.route, 'properties.costingOptions.truck')) {
        this.optimizedTruckRoute = true;
      } else {
        this.optimizedTruckRoute = false;
      }

      this.log('trip start:', _.cloneDeep(this.trip));

      _.each(this.trip.waypoints, (w, idx) => {
        let i = getIcon(w);

        this.waypoints.push({
          name: w.name,
          distance: null,
          duration: null,
          icon: i,
          location: w.location,
          address: getAddress(idx + 1),
        });
      });

      if (_.get(trip.destination, 'placeType') === 'CURRENT_LOCATION') {
        this.destination.name = _.get(this.trip.destination, 'description');
      } else {
        this.destination.name =
          _.get(this.trip.destination.location, 'address') ||
          _.get(this.trip.destination, 'name');
      }

      this.destination.distance = null;
      this.destination.duration = null;
      this.destination.location = _.get(this.trip.destination, 'location');

      this.log('this.origin', this.origin);
      this.log('this.waypoints', this.waypoints);
      this.log('this.destination', this.destination);
      this.inited = true;

      if (this.activeTrip) {
        this.calcDistanceAlongRoute();
      }

      function getIcon(w) {
        let icon = '';
        _.each(placeTypes, type => {
          if (type.id === w.placeId) {
            // console.log('type matches', type);
            icon = type.icon;
          }
        });

        return icon;
      }

      function getAddress(i) {
        if (!_.get(trip.route, 'properties')) {
          return '';
        }
        const str = String(
          _.get(trip.route.properties.legs[i], 'startAddress') || ''
        )
          .replace(', USA', '')
          .replace(', United States', '');
        let remainder = str.split(',').slice(-2).join(', ');
        remainder = '123 Street, ' + remainder;
        const newStr = parseAddress.parseLocation(remainder);
        if (newStr.city && newStr.state) {
          return newStr.city + ', ' + newStr.state;
        } else {
          return newStr.city || newStr.state || '';
        }
      }
    });
  }

  private calcDistanceAlongRoute() {
    this.geolocation.getRecentLocationPlace().then(userLocation => {
      this.log('userLocation', userLocation);

      this.getUserDistanceAlongLine(userLocation).then(() => {
        this.setDurationToStops(userLocation, this.destination);
      });
    });
  }

  private setDurationToStops(userLoc, point, pointIndex?) {
    try {
      let userLocation: any = userLoc;
      let nextStop;

      if (!userLocation.location) {
        userLocation = {
          location: {
            type: 'Point',
            coordinates: [userLocation.longitude, userLocation.latitude],
          },
        };
      }

      this.log('will get directions', userLoc, point);

      let coordinatesAlongRoute: any = [
        (userLocation.location.coordinates || []).join(','),
      ];

      if (_.get(this.trip, 'dates.completed')) {
        this.log('trip calc adding origin', this.trip.origin);
        coordinatesAlongRoute = [
          (_.get(this.trip.origin.location, 'coordinates') || []).join(','),
        ];
      }
      this.addWaypointsToArray(coordinatesAlongRoute);
      let dest = (point.location.coordinates || []).join(',');
      this.log('trip calc destination', dest);
      coordinatesAlongRoute.push(dest);

      this.log('trip calc points', coordinatesAlongRoute);

      return this.getDirections(coordinatesAlongRoute).then(
        res => {
          const route: any = _.first(res.routes),
            legs: any = _.get(route, 'legs');
          this.log('trip calc got directions from mapbox', route);
          this.log('trip calc got directions from mapbox', legs);
          if (!route || !legs) {
            return;
          }
          this.updateTripWithDurationsAndDistances(legs, route);
          this.log('trip calc route distance', _.get(route, 'distance'));
          const tripDistanceCalc = _.sumBy(
            this.trip.route.properties.legs,
            l => {
              return _.get(l, 'distance.value');
            }
          );
          this.totalTripMiles = _.round(
            numeral(tripDistanceCalc * 0.000621371)._value
          );

          this.userPercentageAlongRoute = _.round(
            (_.get(this.trip, 'tripStats.totalMiles') / this.totalTripMiles) *
              100
          );

          this.log(
            'trip calc % and total Miles',
            this.userPercentageAlongRoute,
            _.get(this.trip, 'tripStats.totalMiles'),
            this.totalTripMiles
          );
          this.routePercentageComplete.emit(this.userPercentageAlongRoute);
        },
        e => {}
      );
    } catch (e) {
      return Promise.resolve();
    }
  }

  private updateTripWithDurationsAndDistances(legs: any, route: any) {
    let duration = null;
    let distance = null;
    let shift = _.size(this.waypoints) - _.size(legs) + 1;

    if (!_.get(this.trip, 'dates.completed')) {
      _.each(legs, (l, i) => {
        duration += l.duration;
        distance += l.distance;

        _.set(
          this.waypoints[i + shift],
          'distance',
          numeral(distance * 0.000621371).format('0,000') + ' mi'
        );
        _.set(
          this.waypoints[i + shift],
          'duration',
          this.computeDurationStr(duration)
        );
      });
      this.destination.distance =
        numeral(_.get(route, 'distance') * 0.000621371).format('0,000') + ' mi';
      this.destination.duration = this.computeDurationStr(
        _.get(route, 'duration')
      );
    } else {
      if (legs) {
        _.each(legs, (l, i) => {
          duration += l.duration;
          distance += l.distance;
          this.log('trip calc in legs completed');
          if (
            _.get(this.trip, 'tripStats.totalMiles') >=
            numeral(distance * 0.000621371)._value
          ) {
            _.set(this, 'stopsCompleted', i + 1);
          }
        });
      }
    }
  }

  private addWaypointsToArray(coordinatesAlongRoute: any) {
    _.each(this.waypoints, (waypoint, i) => {
      this.log('userDotIndex?????', this.userDotLocationIndex);
      let userIndex = _.get(this, 'userDotLocationIndex');
      if (userIndex === 'start') {
        userIndex = -1;
      }
      if (i > userIndex) {
        this.log('userDotIndex ADDDING', i);
        let pt = (waypoint.location.coordinates || []).join(',');
        coordinatesAlongRoute.push(pt);
      }
    });
  }

  private getDirections(points) {
    try {
      const existing = _.find(this.staticRouteCache, info => {
        const originDist = turf.distance(
          turf.point(points[0].split(',')),
          turf.point(info.points[0].split(',')),
          {
            units: 'miles',
          }
        );

        if (originDist > 2) {
          return;
        }

        const destDist = turf.distance(
          turf.point(points[1].split(',')),
          turf.point(info.points[1].split(',')),
          {
            units: 'miles',
          }
        );

        if (destDist > 2) {
          return;
        }

        return true;
      });

      if (existing) {
        this.log('already had route', existing);
        return Promise.resolve(existing.res);
      }
    } catch (e) {
      this.log('error', e);
    }

    return $.get(
      `https://api.mapbox.com/directions/v5/mapbox/driving/${points.join(';')}`,
      {
        access_token: this.env.mapboxglAccessToken,
        steps: true,
        alternatives: true,
        geometries: 'geojson',
        overview: 'simplified',
      }
    ).then(res => {
      this.staticRouteCache.push({
        points: points,
        res: res,
      });

      if (_.size(this.staticRouteCache) > 50) {
        this.staticRouteCache.shift();
      }

      return res;
    });
  }

  private getUserDistanceAlongLine(point) {
    return new Promise<void>((resolve, reject) => {
      let lastDistanceAlong = 0,
        trip = this.trip,
        distanceAlongRoute = this.pointDistanceAlongTrip(trip, point),
        found;

      this.userDotActiveWaypoint = null;
      this.userDistanceAlongRoute = _.round(distanceAlongRoute);

      _.each(trip.waypoints, (wp, index) => {
        this.log('setting index???', index, _.size(trip.waypoints) - 1);

        const wpDistance = this.pointDistanceAlongTrip(trip, wp),
          distanceBetweenPoints = this.distanceBetweenPoints(point, wp);

        if (distanceBetweenPoints < 2) {
          this.userDotActiveWaypoint = index;
        }

        if (wpDistance > distanceAlongRoute) {
          let percent =
            (distanceAlongRoute - lastDistanceAlong) /
            (wpDistance - lastDistanceAlong);

          this.userDotLocation = this.getDistPercentage(percent);
          this.userDotLocationIndex = index;

          if (this.userDotLocationIndex == 0) {
            // this.log('userDotLoc at START');
            this.userDotLocationIndex = 'start';
            found = true;
            return false;
          } else {
            // this.log('userDotLoc on WAYPOINT');
            this.userDotLocationIndex = _.parseInt(index) - 1;
            found = true;
            return false;
          }
        }

        lastDistanceAlong = wpDistance;
      });

      if (!found) {
        // this.log('userDotLoc at END');
        this.userDotLocationIndex = trip.waypoints.length - 1;
        let percent =
          (distanceAlongRoute - lastDistanceAlong) /
          (this.pointDistanceAlongTrip(trip, trip.destination) -
            lastDistanceAlong);
        this.userDotLocation = this.getDistPercentage(percent);
      }
      if (this.userDotLocationIndex === -1) {
        // need to reset to start
        this.userDotLocationIndex = 'start';
      }

      // this.log('final userDotLocationIndex', this.userDotLocationIndex);
      // this.log('final userDotLocation', this.userDotLocation);
      resolve();
    });
  }

  private getDistPercentage(percentage) {
    const min = 0,
      max = 0.7;
    return String(_.round(percentage * (max - min) + min, 4) * 100) + '%';
    // percentage needs to be between 30 and 82 to show up correctly
    // calculating below the percentage between the percentage values
  }

  private distanceBetweenPoints(from, to) {
    this.log('distance between points', from, to);
    if (!from.location) {
      from = {
        location: {
          type: 'Point',
          coordinates: [from.longitude, from.latitude],
        },
      };
    }
    if (!to.location) {
      to = {
        location: {
          type: 'Point',
          coordinates: [to.longitude, to.latitude],
        },
      };
    }
    return turf.distance(
      {
        type: 'Feature',
        properties: {},
        geometry: from && from.location,
      },
      {
        type: 'Feature',
        properties: {},
        geometry: to && to.location,
      },
      {
        units: 'miles',
      }
    );
  }

  private pointDistanceAlongTrip(trip, point) {
    this.log('distance on line', point);
    if (!_.get(point, 'location.coordinates')) {
      return 0;
    }
    // this.log('pointDistanceAlongTrip', point, trip);
    const pointOnLine = turf.nearestPointOnLine(trip.route, {
      type: 'Feature',
      properties: {},
      geometry: _.get(point, 'location'),
    });
    this.log(
      'distance on line',
      _.get(pointOnLine, 'properties.location', 100000)
    );
    return _.get(pointOnLine, 'properties.location', 100000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
    _.each(this.subs, fn => {
      // works for event emitter and observables
      if (fn && fn.unsubscribe) {
        fn.unsubscribe();
      } else {
        fn && fn();
      }
    });
  }

  private computeDurationStr(duration) {
    let hr = 0,
      min = 0;
    if (duration > 3600) {
      hr += Math.floor(duration / 3600);
      duration -= hr * 3600;
    }

    min += Math.floor(duration / 60);

    if (hr && min) {
      return `${hr} hr ${min} min`;
    } else if (hr) {
      return `${hr} hr`;
    } else {
      return `${min} min`;
    }
  }

  private setHeights() {
    const buttons = $('.TripTimelineButtons').height(),
      tabs = $('ion-tabs .tabbar').height(),
      extra = 200;

    $('.Timeline-stats').css({
      'max-height': window.innerHeight - tabs - extra + 'px',
      'padding-bottom': buttons + 50 + 'px',
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/trip-timeline/trip-timeline.ts